import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import SearchModal from "@/components/SearchModal";

const MobileBottomNav: React.FC = () => {
  const { user, logout, hasActiveSubscription } = useAuth();
  const [searchOpen, setSearchOpen] = useState(false);

  const handleLogoutClick = async () => {
    await logout();
    window.location.href = "/";
  };

  return (
    <>
      <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} />

      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          height: 56,
          backgroundColor: "#1b1324",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          zIndex: 1100,
        }}
      >
        {/* Home Logo */}
        <IconButton component={Link} to={user ? (hasActiveSubscription ? "/discover" : "/") : "/"}>
          <img
            src="/logo2.png"
            alt="Lsnto Logo"
            style={{ maxHeight: "32px", width: "auto", cursor: "pointer" }}
          />
        </IconButton>

        {/* Search - triggers modal now */}
        <IconButton onClick={() => setSearchOpen(true)}>
          <SearchIcon sx={{ color: "white" }} />
        </IconButton>

        {/* Profile (only if authenticated) */}
        {user && (
          <IconButton component={Link} to="/dashboard">
            <AccountCircleIcon sx={{ color: "white" }} />
          </IconButton>
        )}

        {/* Login / Logout */}
        {user ? (
          <IconButton onClick={handleLogoutClick}>
            <LogoutIcon sx={{ color: "white" }} />
          </IconButton>
        ) : (
          <IconButton component={Link} to="/login">
            <LoginIcon sx={{ color: "white" }} />
          </IconButton>
        )}
      </Box>
    </>
  );
};

export default MobileBottomNav;

